export interface IDictionaryTreeRow {
    id: string;
    parent?: string;
    hasChild?: boolean;
}

/**
 * Условие выборки одного уровня иерархического справочника (пустой id — корни).
 *
 * Эндпоинты `dictionaries/items` и `dictionaries/tree/items` берут родителя только
 * из условия фильтра по полю `parent`: query-параметр `parentIds` и поле `parentId`
 * тела запроса уровень не задают. Без этого условия сервер отдаёт весь справочник
 * плоско — на ОКПД2/ОКАТО это минуты и отказ по таймауту.
 */
export const dictLevelFilter = (parentId: string) => ['parent', '=', parentId];

/**
 * Плоский набор узлов (поиск — совпадения вместе с предками, режим «весь
 * справочник») в дерево. Узел, чьего родителя в наборе нет, становится корнем;
 * повторы id отбрасываются — иначе дерево получало бы дубликаты.
 */
export const buildFlatTree = <T extends IDictionaryTreeRow>(rows: T[]) => {
    const unique = new Map<string, T>();
    rows.forEach((row) => {
        if (!unique.has(row.id)) unique.set(row.id, row);
    });
    const children = new Map<string, T[]>();
    const roots: T[] = [];
    unique.forEach((row, id) => {
        const parent = row.parent ?? '';
        if (parent && parent !== id && unique.has(parent)) {
            const list = children.get(parent);
            if (list) list.push(row);
            else children.set(parent, [row]);
        } else {
            roots.push(row);
        }
    });
    return { roots, children };
};
